<template>
  <div class="p-4 bg-gray-100 min-h-screen">
    <Loader v-if="loading" />

    <Card class="shadow-2 surface-card border-round p-4">
      <template v-slot:title>
        <div class="text-2xl font-bold text-gray-800 flex align-items-center mb-4">
          <i class="pi pi-file-upload mr-2 text-primary"></i>
          Gestione Modulistica
        </div>
      </template>

      <template v-slot:content>
        <h4 class="text-lg font-semibold text-primary mb-3">Carica nuovo file</h4>
        <div class="mb-5">
          <FileUpload mode="basic" name="demo[]" :auto="true" :custom-upload="true" @uploader="onFileChange" choose-label="Scegli file" upload-icon="pi pi-upload" />
        </div>

        <h4 class="text-lg font-semibold text-primary mb-3">Documenti caricati</h4>
        <div class="surface-card p-3 border-round shadow-1">
          <DataTable :value="transactions" stripedRows responsiveLayout="scroll">
            <template #empty>
              <div class="text-center text-sm text-gray-400 py-3">Nessun documento caricato.</div>
            </template>
            <Column field="creation_time" header="Data" style="width: 15%">
              <template #body="{ data }">
                <span>{{ data.creation_time }}</span>
              </template>
            </Column>
            <Column field="nome" header="Nome" style="width: 40%"></Column>
            <Column header="Anteprima" style="width: 15%">
              <template #body="{ data }">
                <Button @click="getDocUrl(data.path)" icon="pi pi-file-pdf" class="p-button-rounded p-button-text p-button-sm p-button-info" v-tooltip.top="'Vedi documento'"/>
              </template>
            </Column>
            <Column header="Visibile" style="width: 15%">
              <template #body="{ data }">
                <InputSwitch :model-value="data.visibile === 1" @click="openConfirmDialog(data.id, data.visibile)"/>
              </template>
            </Column>
            <Column header="Azioni" style="width: 15%">
              <template #body="{ data }">
                <Button @click="openConfirmDialogTrash(data.id)" icon="pi pi-trash" class="p-button-rounded p-button-danger p-button-sm" v-tooltip.top="'Elimina documento'" />
              </template>
            </Column>
          </DataTable>
        </div>
      </template>
    </Card>

    <Dialog v-model:visible="confirmDialog.visible" header="Conferma la visibilità" :modal="true" :style="{ width: '400px' }">
      <div class="text-center">
        <i class="pi pi-exclamation-triangle text-4xl text-yellow-500 mb-3"></i>
        <p>Sei sicuro di voler cambiare la visibilità di questo documento?</p>
      </div>
      <template #footer>
        <div class="flex justify-content-center">
          <Button label="Annulla" @click="confirmDialogReject" icon="pi pi-times" class="p-button-text p-button-secondary" />
          <Button label="Procedi" @click="confirmDialogAccept" icon="pi pi-check" class="p-button-primary" />
        </div>
      </template>
    </Dialog>

    <Dialog v-model:visible="confirmDialogTrash.visible" header="Conferma l'eliminazione" :modal="true" :style="{ width: '400px' }">
      <div class="text-center">
        <i class="pi pi-times-circle text-4xl text-red-500 mb-3"></i>
        <p>Sei sicuro di voler eliminare definitivamente questo documento?</p>
      </div>
      <template #footer>
        <div class="flex justify-content-center">
          <Button label="Annulla" @click="confirmDialogTrashReject" icon="pi pi-times" class="p-button-text p-button-secondary" />
          <Button label="Procedi" @click="confirmDialogTrashAccept" icon="pi pi-check" class="p-button-danger" />
        </div>
      </template>
    </Dialog>
    
    </div>
</template>

<script>
import {ref,onMounted, getCurrentInstance } from 'vue';
import Service from '@/services/levante-api/levante-api'
import Loader from "@/components/Loader.vue";
import { useToast } from 'primevue/usetoast';
export default {
    components(){
        return [
            Loader
        ]
    },
    data() {
        return {
            showModal: false,
            selectedTransaction: null,
            selectedAtleta: '',
        };
    },
    methods: {
       
     
        contabilizza(transaction) {
            this.selectedTransaction = transaction;
            this.showModal = true;
        },
        submitContabilizza() {
            // Logica per contabilizzare la transazione con l'atleta selezionato
            this.showModal = false;
        }
    },
    setup(){
        const self = getCurrentInstance();
        self.$eventBus = self.appContext.config.globalProperties.$eventBus
        const service = new Service(self.$eventBus);
        const toast = useToast();
        const transactions = ref({})
        const atleti = ref({})

        const loading = ref(false)
        const lifeTime = 3000;
        const confirmDialog = ref({
      visible: false,
      id: null,
      visibile: null
    });
    const confirmDialogTrash = ref({
      visible: false,
      id: null,
      visibile: null
    });


    const openConfirmDialogTrash= (id, visibile) => {
      confirmDialogTrash.value.visible = true;
      confirmDialogTrash.value.id = id;
      confirmDialogTrash.value.visibile = visibile;
    };

    
    const confirmDialogTrashAccept = () => {
      deleteValue(confirmDialogTrash.value.id);
      confirmDialogTrash.value.visible = false;
    };

    const confirmDialogTrashReject = () => {
      toast.add({ severity: 'error', summary: 'Annullato', detail: 'Operazione annullata', life: 3000 });
      confirmDialogTrash.value.visible = false;
    };


        const fetchData = async() => {
            const response = await service.getAllModulistica();
            console.log(response);
            transactions.value = response.items;

        };
     
        const getDocUrl = (imgPath) => {
            window.open( `${process.env.VUE_APP_LEVANTE_API_URL}/../storage/app/public/${imgPath}`);
        }
        
        const openConfirmDialog = (id, visibile) => {
        confirmDialog.value.visible = true;
        confirmDialog.value.id = id;
        confirmDialog.value.visibile = visibile;
        };
        const toggleVisibile = async (id,visibile) => {
            visibile = visibile === 0 ? 1 : 0;
            loading.value = true;

            try {
                let fd = new FormData();  
                fd.append('visibile',visibile);
                await service.updateVisibileModulistica(id,fd);  // assuming this endpoint exists
                toast.add({ severity: 'success', summary: 'Successo', detail: 'Visibilità aggiornata con successo',life: lifeTime});
                fetchData();
            } catch (error) {
                toast.add({ severity: 'error', summary: 'Errore', detail: 'Errore durante l\'aggiornamento della visibilità',life: lifeTime });
            } finally {
                loading.value = false;
            }
        };
        const confirmDialogAccept = () => {
        toggleVisibile(confirmDialog.value.id, confirmDialog.value.visibile);
        confirmDialog.value.visible = false;
        };

        const confirmDialogReject = () => {
        toast.add({ severity: 'error', summary: 'Annullato', detail: 'Operazione annullata', life: 3000 });
        confirmDialog.value.visible = false;
        };

           const deleteValue = async (id) => {
      loading.value = true;

      try {
        await service.deleteModulistica(id);  // assuming this endpoint exists
        toast.add({ severity: 'success', summary: 'Successo', detail: 'Cancellazione effettuata con successo',life: lifeTime});
        fetchData();
      } catch (error) {
        toast.add({ severity: 'error', summary: 'Errore', detail: 'Errore durante la cancellazione',life: lifeTime });
      } finally {
        loading.value = false;
      }
    };

        const onFileChange = async (event) => {
    // La proprietà 'files' è sull'oggetto 'event' stesso, non su 'event.target'
    const file = event.files[0];

    // Resto del codice...
    let formData = new FormData();
    formData.append('file', file);

    try {
        const res = await service.sendModulistica(formData);
        let severity = res.item.esito
                    let summary = res.item.esito != 'success' ? 'Attenzione' : 'Successo'
                    let detail = res.item.messaggio
                    if (severity != 'warning') {
                        toast.add({severity:severity, summary: summary, detail:detail,life:lifeTime});                            
                    }
                    fetchData()
        // ... Logica per la gestione della risposta
    } catch (error) {
        // ... Logica per la gestione dell'errore
    }
};
        const onChangeInput = (evt, prop) => {
             let value
            switch (prop) {
                case 'atleta':
                value = evt.value
                break;
                
                default:
                value = evt.target.value
                break;
            }
            
            
            };
        onMounted(() => { 
            loading.value = true
            const promises = [fetchData()]
            
            Promise.all(promises)
            .finally(()=>{
                loading.value = false
            })
        })
        return {
            onFileChange,onChangeInput,loading,transactions,atleti,openConfirmDialog,
            confirmDialog,
            confirmDialogReject,
            confirmDialogAccept,getDocUrl,
            openConfirmDialogTrash,
            confirmDialogTrash,
            confirmDialogTrashReject,
            confirmDialogTrashAccept
        };
    },
   
}
</script>

<style scoped>
.modal {
    position: fixed;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    background: white;
    padding: 1em;
    border: 1px solid #ccc;
}

.confirm-dialog {
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  background: white;
  padding: 20px;
  box-shadow: 0 2px 10px rgba(0,0,0,0.2);
  z-index: 1000;
}

.confirm-dialog-content {
  text-align: center;
}

.confirm-dialog-content h3 {
  margin-top: 0;
}

.confirm-dialog-content button {
  margin: 10px;
}
</style>
